var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoHeader',[_c('img',{class:_vm.$style.image,attrs:{"src":require("@/assets/img/rhino.png")}}),_vm._v(" Mood ")])
}
var staticRenderFns = []

export { render, staticRenderFns }